/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
import { StrikePrice } from "../../Price/PriceInfo";
import { Image } from "../../Media/Image";
import {
  MasterData_CategoryType,
  Rating,
  masterData_CategoryTypeToNumber,
  masterData_CategoryTypeFromJSON,
  masterData_CategoryTypeToJSON,
} from "../Hotel";

export interface HotelRecommendation {
  traveller: number;
  price: number;
  url: string;
  ratingUrl: string;
  masterData?: MasterData;
  strikePrice?: StrikePrice;
}

export interface MasterData {
  isHolidayHome: boolean;
  id: number;
  hotelCategory: number;
  hotelName: string;
  cityName: string;
  displayedDestination: string;
  destinationLabel: string;
  image?: Image;
  hotelCategoryType: MasterData_CategoryType;
  rating?: Rating;
}

function createBaseHotelRecommendation(): HotelRecommendation {
  return {
    traveller: 0,
    price: 0,
    url: "",
    ratingUrl: "",
    masterData: undefined,
    strikePrice: undefined,
  };
}

export const HotelRecommendation = {
  encode(
    message: HotelRecommendation,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.traveller !== 0) {
      writer.uint32(8).uint32(message.traveller);
    }
    if (message.price !== 0) {
      writer.uint32(21).float(message.price);
    }
    if (message.url !== "") {
      writer.uint32(26).string(message.url);
    }
    if (message.ratingUrl !== "") {
      writer.uint32(34).string(message.ratingUrl);
    }
    if (message.masterData !== undefined) {
      MasterData.encode(message.masterData, writer.uint32(42).fork()).ldelim();
    }
    if (message.strikePrice !== undefined) {
      StrikePrice.encode(
        message.strikePrice,
        writer.uint32(50).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HotelRecommendation {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHotelRecommendation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.traveller = reader.uint32();
          break;
        case 2:
          message.price = reader.float();
          break;
        case 3:
          message.url = reader.string();
          break;
        case 4:
          message.ratingUrl = reader.string();
          break;
        case 5:
          message.masterData = MasterData.decode(reader, reader.uint32());
          break;
        case 6:
          message.strikePrice = StrikePrice.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): HotelRecommendation {
    return {
      traveller: isSet(object.traveller) ? Number(object.traveller) : 0,
      price: isSet(object.price) ? Number(object.price) : 0,
      url: isSet(object.url) ? String(object.url) : "",
      ratingUrl: isSet(object.ratingUrl) ? String(object.ratingUrl) : "",
      masterData: isSet(object.masterData)
        ? MasterData.fromJSON(object.masterData)
        : undefined,
      strikePrice: isSet(object.strikePrice)
        ? StrikePrice.fromJSON(object.strikePrice)
        : undefined,
    };
  },

  toJSON(message: HotelRecommendation): unknown {
    const obj: any = {};
    message.traveller !== undefined &&
      (obj.traveller = Math.round(message.traveller));
    message.price !== undefined && (obj.price = message.price);
    message.url !== undefined && (obj.url = message.url);
    message.ratingUrl !== undefined && (obj.ratingUrl = message.ratingUrl);
    message.masterData !== undefined &&
      (obj.masterData = message.masterData
        ? MasterData.toJSON(message.masterData)
        : undefined);
    message.strikePrice !== undefined &&
      (obj.strikePrice = message.strikePrice
        ? StrikePrice.toJSON(message.strikePrice)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<HotelRecommendation>): HotelRecommendation {
    const message = createBaseHotelRecommendation();
    message.traveller = object.traveller ?? 0;
    message.price = object.price ?? 0;
    message.url = object.url ?? "";
    message.ratingUrl = object.ratingUrl ?? "";
    message.masterData =
      object.masterData !== undefined && object.masterData !== null
        ? MasterData.fromPartial(object.masterData)
        : undefined;
    message.strikePrice =
      object.strikePrice !== undefined && object.strikePrice !== null
        ? StrikePrice.fromPartial(object.strikePrice)
        : undefined;
    return message;
  },
};

function createBaseMasterData(): MasterData {
  return {
    isHolidayHome: false,
    id: 0,
    hotelCategory: 0,
    hotelName: "",
    cityName: "",
    displayedDestination: "",
    destinationLabel: "",
    image: undefined,
    hotelCategoryType: MasterData_CategoryType.Star,
    rating: undefined,
  };
}

export const MasterData = {
  encode(
    message: MasterData,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isHolidayHome === true) {
      writer.uint32(8).bool(message.isHolidayHome);
    }
    if (message.id !== 0) {
      writer.uint32(16).uint32(message.id);
    }
    if (message.hotelCategory !== 0) {
      writer.uint32(29).float(message.hotelCategory);
    }
    if (message.hotelName !== "") {
      writer.uint32(34).string(message.hotelName);
    }
    if (message.cityName !== "") {
      writer.uint32(42).string(message.cityName);
    }
    if (message.displayedDestination !== "") {
      writer.uint32(82).string(message.displayedDestination);
    }
    if (message.destinationLabel !== "") {
      writer.uint32(50).string(message.destinationLabel);
    }
    if (message.image !== undefined) {
      Image.encode(message.image, writer.uint32(90).fork()).ldelim();
    }
    if (message.hotelCategoryType !== MasterData_CategoryType.Star) {
      writer
        .uint32(56)
        .int32(masterData_CategoryTypeToNumber(message.hotelCategoryType));
    }
    if (message.rating !== undefined) {
      Rating.encode(message.rating, writer.uint32(74).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MasterData {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMasterData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.isHolidayHome = reader.bool();
          break;
        case 2:
          message.id = reader.uint32();
          break;
        case 3:
          message.hotelCategory = reader.float();
          break;
        case 4:
          message.hotelName = reader.string();
          break;
        case 5:
          message.cityName = reader.string();
          break;
        case 10:
          message.displayedDestination = reader.string();
          break;
        case 6:
          message.destinationLabel = reader.string();
          break;
        case 11:
          message.image = Image.decode(reader, reader.uint32());
          break;
        case 7:
          message.hotelCategoryType = masterData_CategoryTypeFromJSON(
            reader.int32()
          );
          break;
        case 9:
          message.rating = Rating.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): MasterData {
    return {
      isHolidayHome: isSet(object.isHolidayHome)
        ? Boolean(object.isHolidayHome)
        : false,
      id: isSet(object.id) ? Number(object.id) : 0,
      hotelCategory: isSet(object.hotelCategory)
        ? Number(object.hotelCategory)
        : 0,
      hotelName: isSet(object.hotelName) ? String(object.hotelName) : "",
      cityName: isSet(object.cityName) ? String(object.cityName) : "",
      displayedDestination: isSet(object.displayedDestination)
        ? String(object.displayedDestination)
        : "",
      destinationLabel: isSet(object.destinationLabel)
        ? String(object.destinationLabel)
        : "",
      image: isSet(object.image) ? Image.fromJSON(object.image) : undefined,
      hotelCategoryType: isSet(object.hotelCategoryType)
        ? masterData_CategoryTypeFromJSON(object.hotelCategoryType)
        : MasterData_CategoryType.Star,
      rating: isSet(object.rating) ? Rating.fromJSON(object.rating) : undefined,
    };
  },

  toJSON(message: MasterData): unknown {
    const obj: any = {};
    message.isHolidayHome !== undefined &&
      (obj.isHolidayHome = message.isHolidayHome);
    message.id !== undefined && (obj.id = Math.round(message.id));
    message.hotelCategory !== undefined &&
      (obj.hotelCategory = message.hotelCategory);
    message.hotelName !== undefined && (obj.hotelName = message.hotelName);
    message.cityName !== undefined && (obj.cityName = message.cityName);
    message.displayedDestination !== undefined &&
      (obj.displayedDestination = message.displayedDestination);
    message.destinationLabel !== undefined &&
      (obj.destinationLabel = message.destinationLabel);
    message.image !== undefined &&
      (obj.image = message.image ? Image.toJSON(message.image) : undefined);
    message.hotelCategoryType !== undefined &&
      (obj.hotelCategoryType = masterData_CategoryTypeToJSON(
        message.hotelCategoryType
      ));
    message.rating !== undefined &&
      (obj.rating = message.rating ? Rating.toJSON(message.rating) : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<MasterData>): MasterData {
    const message = createBaseMasterData();
    message.isHolidayHome = object.isHolidayHome ?? false;
    message.id = object.id ?? 0;
    message.hotelCategory = object.hotelCategory ?? 0;
    message.hotelName = object.hotelName ?? "";
    message.cityName = object.cityName ?? "";
    message.displayedDestination = object.displayedDestination ?? "";
    message.destinationLabel = object.destinationLabel ?? "";
    message.image =
      object.image !== undefined && object.image !== null
        ? Image.fromPartial(object.image)
        : undefined;
    message.hotelCategoryType =
      object.hotelCategoryType ?? MasterData_CategoryType.Star;
    message.rating =
      object.rating !== undefined && object.rating !== null
        ? Rating.fromPartial(object.rating)
        : undefined;
    return message;
  },
};

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
